import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import ScrollToTop from "@/components/ScrollToTop";
import PageViewTracker from "@/components/PageViewTracker";
import TrueWellness from "./pages/TrueWellness";
import WellnessBlog from "./pages/WellnessBlog";
import WellnessBlogPost from "./pages/WellnessBlogPost";
import AdminPortal from "./pages/AdminPortal";
import AdminLogin from "./pages/AdminLogin";
import AdminSignup from "./pages/AdminSignup";
import Employers from "./pages/Employers";
import Locations from "./pages/Locations";
import LocationDetail from "./pages/LocationDetail";
import NotFound from "./pages/NotFound";

const queryClient = new QueryClient();

const App = () => (
  <HelmetProvider>
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <ScrollToTop />
          <PageViewTracker />
          <Routes>
            <Route path="/" element={<TrueWellness />} />
            <Route path="/wellness" element={<TrueWellness />} />
            <Route path="/employers" element={<Employers />} />
            <Route path="/locations" element={<Locations />} />
            <Route path="/locations/:id" element={<LocationDetail />} />
            
            <Route path="/wellness/blog" element={<WellnessBlog />} />
            <Route path="/wellness/blog/:postId" element={<WellnessBlogPost />} />
            <Route path="/admin" element={<AdminPortal />} />
            <Route path="/admin/portal" element={<AdminPortal />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/signup" element={<AdminSignup />} />
            <Route path="*" element={<TrueWellness />} />
          </Routes>
        </BrowserRouter>
      </TooltipProvider>
    </QueryClientProvider>
  </HelmetProvider>
);

export default App;
